export default __webpack_public_path__ + "static/media/Sepp-auf-Wiese.711ec17f.png";